import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mockData';

const FAQSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-white via-[#FDFEFE] to-white relative overflow-hidden">
      {/* Decorative shapes */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-[#C0392B]/10 rounded-full blur-2xl" />
      <div className="absolute top-40 right-20 w-40 h-40 bg-[#7F8C8D]/10 rounded-full blur-2xl" />
      <div className="absolute bottom-20 left-1/3 w-36 h-36 bg-[#C0392B]/10 rounded-full blur-2xl" />
      
      <div className="container mx-auto px-4 max-w-[1320px] relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C3E50]">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-[#7F8C8D] max-w-3xl mx-auto">
            Get answers to common questions about trademark registration and our services
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border-2 border-[#7F8C8D]/20 rounded-lg px-6 hover:border-[#C0392B]/50 transition-colors"
              >
                <AccordionTrigger className="text-left text-[#2C3E50] hover:text-[#C0392B] font-semibold text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#7F8C8D] leading-relaxed pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

      </div>
    </section>
  );
};

export default FAQSection;